import apiClient from './apiClient';
import { GET_LIST_PENDING_APPROVAL_COMPANY_URL } from './apiUrl';

const getCompanyForApprovalApi = () => {
  return apiClient.get(GET_LIST_PENDING_APPROVAL_COMPANY_URL);
};

export default getCompanyForApprovalApi;
